<script lang="ts" setup>
  import { SITE_ENVIRONMENTS } from './constants/siteEnvironment'
  import { useRoute } from 'vue-router'

  import ABCGrowE from '~/assets/fonts/ABCGrow-E.woff2?url'
  import ABCDiatypeRegular from '~/assets/fonts/ABCDiatype-Regular.woff2?url'
  import ABCDiatypeBold from '~/assets/fonts/ABCDiatype-Bold.woff2?url'

  if (import.meta.server) {
    useHead({
      link: [
        {
          rel: 'preload',
          href: ABCGrowE,
          as: 'font',
          type: 'font/woff2',
          crossorigin: ''
        },
        {
          rel: 'preload',
          href: ABCDiatypeBold,
          as: 'font',
          type: 'font/woff2',
          crossorigin: ''
        },
        {
          rel: 'preload',
          href: ABCDiatypeRegular,
          as: 'font',
          type: 'font/woff2',
          crossorigin: ''
        }
      ]
    })
  }

  type LayoutName = 'with-ordering-app' | 'default'

  const $config = useRuntimeConfig()

  const defaultLayout: LayoutName =
    new Map<string, LayoutName>([
      [SITE_ENVIRONMENTS.AUSTRALIA, 'with-ordering-app'],
      [SITE_ENVIRONMENTS.INDONESIA, 'default']
    ]).get($config.public.siteEnvironment) || 'default'

  // This is the key: usePageLayout() returns the layout requested by definePageMeta, or undefined
  const route = useRoute()

  const layout = computed(() => {
    // Nuxt 3 expects false | string | undefined
    // nuxtApp.isHydrating is true during hydration, so fallback to defaultLayout if meta.layout is not set
    const metaLayout = route.meta.layout
    return typeof metaLayout === 'string' ? metaLayout : defaultLayout
  })
</script>

<template>
  <NuxtLayout :name="layout">
    <NuxtPage />
  </NuxtLayout>
</template>

<style lang="scss">
  @import '@/styles/main.scss';

  body {
    background: var(--color-secondary-paper-lightest);
    font-family: var(--font-family-base);
  }
</style>
